import React, { useEffect, useState } from 'react'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'
import { Link } from 'react-router-dom';
import { Row } from 'reactstrap';
import axios from '../../API/axios';
import { ShimmerDiv } from 'shimmer-effects-react';
import LoginMobileHeader from '../../components/header/LoginMobileHeader';
import InstituteMobileHeader from '../../components/header/InstituteMobileHeader';
import CRMobileHeader from '../../components/header/CRMobileHeader';
import MobileHeader from '../../components/header/MobileHeader';
import LoginHeader from '../../components/header/LoginHeader';
import InstituteHeader from '../../components/header/InstituteHeader';
import CRHeader from '../../components/header/CRHeader';
import NonLoginHeader from '../../components/header/NonLoginHeader';
import { Helmet } from 'react-helmet';
import error from "../../assets/images/Not-Found.png";

function Institute() {
	const [isLoading, setIsLoading] = useState(true);
	const [companyList, setCompanyList] = useState([]);
	const [institutes, setInstitutes] = useState([]);
	const [userList, setUserList] = useState([]);
	const [searchuserList, setSearchuserList] = useState([]);
	const [nextBatchLoading, setNextBatchLoading] = useState('')
	const [isError, setIsError] = useState(false);
	const [page, setPage] = useState(0);
	const [totalPages, setTotalPages] = useState(0);
	const [loading, setLoading] = useState(false);
	const token = localStorage.getItem('token')
	const [hasMoreData, setHasMoreData] = useState(true);



	const getInstituteList = (page, searchUserName) => {
		setNextBatchLoading(true);
		const data = {
			pageNumber: page,
			pageSize: 10,
		};
		axios
			.post(`/Institute/GetAll?Search=${institutes}`, data)
			.then((response) => {
				setIsLoading(false);
				console.log("people res", response);

				const totalPages = response.data.responseData.paging.totalPages;
				setTotalPages(totalPages);
				if (page >= response.data.responseData.paging.totalPages) {
					setHasMoreData(false);
				}
				const newPosts = response.data.responseData.instituteProfiles;
				if (newPosts.length === 0) {
					setIsError(true)
				} else {
					setIsError(false)
				}

				if (searchUserName !== '') {
					// return newPosts;
					setUserList([])
					setSearchuserList(newPosts)
				} else {
					setSearchuserList([])
					setUserList((prev) => {
						const userSet = new Set(prev?.map((user) => user?.userUid));
						const uniqueNewPosts = newPosts.filter(
							(user) => !userSet.has(user?.userUid)
						);
						return [...prev, ...uniqueNewPosts];
					});
				}

				if (page >= totalPages) {
					setNextBatchLoading(false); // Stop loading if the last page is reached
				} else {
					setNextBatchLoading(false); // Continue loading for more pages
				}

				console.log("all post data", newPosts);
			})
			.catch((error) => {
				if (error.response && error.response.status === 404) {
					setIsError(true);
				} else {
					console.log(error);
				}
				setIsLoading(false);
				setNextBatchLoading(false);
			});
	};

	useEffect(() => {
		setUserList([]); // Reset user list when searchUserName changes
		getInstituteList(1, institutes); // Start from page 1 for a new search
	}, [institutes]);

	useEffect(() => {
		if (page <= totalPages) {
			getInstituteList(page, institutes);
		}
	}, [page]);

	const handleInfiniteScroll = async () => {
		try {
			if (window.innerHeight + document.documentElement.scrollTop + 1 >=
				document.documentElement.scrollHeight) {
				setLoading(true);
				console.log('log', page, totalPages);

				page < totalPages && setPage((prev) => prev + 1);
			}
		} catch (error) {
			console.error(error);
		}
	};

	useEffect(() => {
		window.addEventListener("scroll", handleInfiniteScroll);
		return () => window.removeEventListener("scroll", handleInfiniteScroll);
	}, []);

	const [isShowMobile, setShowMobile] = useState(false);

	const handleMobile = () => {
		const getMobile = document.querySelector(".menu-mobile-popup");
		setShowMobile(!isShowMobile);
		!isShowMobile
			? getMobile.classList.add("modal-menu--open")
			: getMobile.classList.remove("modal-menu--open");
	};

	const module = localStorage.getItem('Module')

	return (
		<>
			<Helmet>
				<title>Institute | Jobkikhoj</title>
				<meta name="description" content=" " />
				<meta name="keywords" content=" " />
				<meta property="og:title" content="Institute | Jobkikhoj " />
				<meta property="og:description" content="" />
				<meta property="og:url" content="https://jobkikhoj.com" />
			</Helmet>
			{module === 'Candidate' ? <LoginMobileHeader handleMobile={handleMobile} /> :
				module === 'Institution' ? <InstituteMobileHeader handleMobile={handleMobile} /> :
					module === 'Company' ? <CRMobileHeader handleMobile={handleMobile} /> :
						module === 'Recruiter' ? <CRMobileHeader handleMobile={handleMobile} /> :
							<MobileHeader handleMobile={handleMobile} />}
			{module === 'Candidate' ? <LoginHeader clname="AddProfile" handleMobile={handleMobile} /> :
				module === 'Institution' ? <InstituteHeader clname="AddProfile" handleMobile={handleMobile} /> :
					module === 'Company' ? <CRHeader clname="AddProfile" handleMobile={handleMobile} /> :
						module === 'Recruiter' ? <CRHeader clname="AddProfile" handleMobile={handleMobile} /> :
							<NonLoginHeader clname="AddProfile" handleMobile={handleMobile} />}



			<div className="pt-70">
				<section className={`inner-employer-section PeopleSearch pt-5`}>
					<div className="container">
						<Tabs className="cl8 tf-tab jobcontent">
							<Row>
								<div className="wd-meta-select-job ">
									<div className="wd-findjob-filer justify-content-center">
										<div className="group-select-display"></div>
										<div className="form-group-1" style={{ borderRadius: "6px" }}>
											<input
												type="email"
												className="form-control p-2 Dark-Input-from-group"
												style={{ borderRadius: "6px" }}
												id="exampleInputEmail1"
												aria-describedby="emailHelp"
												placeholder="Search Institute"
												onChange={(e) => {
													setInstitutes(e.target.value);
													getInstituteList();
												}}
												value={institutes}
											/>
										</div>
									</div>
								</div>
							</Row>

							<div className="content-tab">
								{/* Tab content for employer listings */}
								<TabPanel
									className="inner"
									style={{
										minHeight: isLoading || nextBatchLoading ? '600px' : 'auto',
										height: 'auto',
									}}
								>
									<div className="Search-job-group row ">
										{isLoading ? (
											<div className="row mt-2">
												{[...Array(6)].map((_, i) => (
													<div key={i} className="col-md-4 mt-2">
														<ShimmerDiv mode="light" height={100} width="100%" />
													</div>
												))}
											</div>
										) : isError ? (
											<div className="mt-6 d-flex justify-content-center">
												<img src={error} alt="404 Not Found" width={300} />
											</div>
										) : searchuserList.length === 0 && userList.length > 0 ? (
											userList.map((institute, index) => (
												<div key={index} className="employer-block Institue-cards-block style-2 cl2 col-md-4">
													<div className="inner-box">
														<div className="logo-company">
															<img src={institute.logoImage} alt="User Logo" />
														</div>
														<div className="box-content">
															<h3 className="mb-0 institutename">
																{token === null ? institute.name :
																	<Link to={`/Institute/${institute.uid}`} >{institute.name}
																	</Link>}
															</h3>
															{institute.cityName === null ? "" : (
																<>
																	<p className="info">
																		<span className="icon-map-pin me-2"></span>
																		{institute.cityName}
																	</p>
																</>
															)}
														</div>
														<div className="button-readmore">
														</div>
													</div>
												</div>
											))
										) : (
											searchuserList.map((institute, index) => (
												<div key={index} className="employer-block Institue-cards-block style-2 cl2 col-md-4">
													<div className="inner-box">
														<div className="logo-company">
															<img src={institute.logoImage} alt="User Logo" />
														</div>
														<div className="box-content">
																<h3 className="mb-0 institutename">
																{token === null ? institute.name :
																	<Link to={`/Institute/${institute.uid}`} >{institute.name}
																	</Link>}
															</h3>
															{institute.cityName === null ? "" : (
																<>
																	<p className="info">
																		<span className="icon-map-pin me-2"></span>
																		{institute.cityName}
																	</p>
																</>
															)}
														</div>
														<div className="button-readmore">
														</div>
													</div>
												</div>
											))
										)}
									</div>
								</TabPanel>
							</div>
						</Tabs>
					</div>
				</section>
			</div>

		</>

	);
}
export default Institute